var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"markdown-body",domProps:{"innerHTML":_vm._s('' + _vm.parse(_vm.content))}})])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }